/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Bounds_LabelInputs */

const cs_pipelines_bounds_label = /** @type {(inputs: Pipelines_Bounds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fáze pipeline`)
};

const en_pipelines_bounds_label = /** @type {(inputs: Pipelines_Bounds_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline stages`)
};

/**
* | output |
* | --- |
* | "Pipeline stages" |
*
* @param {Pipelines_Bounds_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_bounds_label = /** @type {((inputs?: Pipelines_Bounds_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Bounds_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_bounds_label(inputs)
	return cs_pipelines_bounds_label(inputs)
});